// extracted by mini-css-extract-plugin
export var subtitle = "_b7-2";
export var title = "_b7-0";
export var titleNoWrap = "_b7-1";